import axios from 'axios'
const URL_PLANTS = '/plants';
const URL_CATEGORIES = '/categories'
export default {
  getIdFromCategory(label) {
    const categoryList = [
      { id: 1, label: 'Tree' },
      { id: 2, label: 'Fern' },
      { id: 3, label: 'Flower' },
      { id: 4, label: 'Succulent' },
      { id: 5, label: 'Grass' }
    ]
    return categoryList.find(category => category.label === label).id
  },
  async getPlants() {
    const URL = `${process.env.VUE_APP_URL_API}` + URL_PLANTS
    let result = null
    try {
      result = await axios.get(URL)
      return result.data.plants;
    } catch (err) {
      result = err.response
      return result
    }
  },
  async getCategories() {
    const URL = `${process.env.VUE_APP_URL_API}` + URL_CATEGORIES
    let result = null
    try {
      result = await axios.get(URL)
      return result.data
    } catch (err) {
      result = err.response
      return result
    }
  },
  async getPlantsByCategory(category) {
    const URL =
      `${process.env.VUE_APP_URL_API}` + URL_PLANTS +
      `/category/` + category + `/` + 'New Zealand';
    let result = null
    try {
      result = await axios.get(URL)
      return result.data
    } catch (err) {
      result = err.response
      return result
    }
  },

  async searchPlant(text) {
    const URL =
      `${process.env.VUE_APP_URL_API}` + URL_PLANTS +
      `/getPlantsByName?s=` +
      text
    let result = null
    try {
      result = await axios.get(URL)
      return result.data
    } catch (err) {
      result = err.response
      return result
    }
  },
  async getPlant(idPlant) {
    const URL =
      `${process.env.VUE_APP_URL_API}` +
      URL_PLANTS +
      `/` +
      idPlant
    let result = null
    try {
      result = await axios.get(URL)
      return result.data[0]
    } catch (err) {
      result = err.response
      return result
    }
  },

}
